
<form [nbSpinner]="loading"
nbSpinnerStatus="danger"
nbSpinnerSize="large"
nbSpinnerMessage="Guardando compañía...">
<div class="row">
<div class="col-md-6">
  <nb-card>
    <nb-card-header>
      <nav class="navbar navigation">
        <span><nb-icon icon="home"></nb-icon> Datos de la compañia - {{companydata.name}}</span>
        <button nbButton status="primary" (click)="back()"><nb-icon icon="arrow-back"></nb-icon>
        </button>

      </nav>

    </nb-card-header>

    <nb-card-body>
      <div class="form-group">
        <label for="companyname" class="label">Nombre</label>
        <input type="text" nbInput fullWidth id="companyname" name="companyname" [(ngModel)]="companydata.name"/>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group">
            <label for="contactmail" class="label">Email de contacto</label>
            <input type="email" nbInput fullWidth id="contactmail" placeholder="empresa@dominio.com" name="contactmail" [(ngModel)]="companydata.contactmail">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label for="contactphone" class="label">Teléfono de contacto</label>
            <input type="phone" nbInput fullWidth id="contactphone" name="contactphone" [(ngModel)]="companydata.contactphone" >
          </div>
        </div>
      </div>

    </nb-card-body>
  </nb-card>
</div>

<div class="col-md-6">
  <nb-card>
    <nb-card-header>
     <nb-icon icon="color-palette"></nb-icon> Configuración Apariencia
    </nb-card-header>

    <nb-card-body>
      <nb-tabset>
        <nb-tab tabTitle="Escritorio" tabIcon="monitor-outline">
          <div class="form-group">
            <label for="desktoplogo" class="label">Logo</label>
            <img class="theme-image" [src]="themeimages.dashboard_theme.logoImage"/>
            <input type="file" nbInput fullWidth id="desktoplogo" name="desktoplogo" (change)="actualizarArchivo('desktoplogo',$event.target.files)"/>
          </div>
          <div class="form-group">
            <label for="desktopbackground" class="label">Imagen de fondo</label>
            <img class="theme-image" [src]="themeimages.dashboard_theme.backgroundImage"/>
            <input type="file" nbInput fullWidth id="desktopbackground" name="desktopbackground" (change)="actualizarArchivo('desktopbackground',$event.target.files)" />
          </div>
        </nb-tab>
        <nb-tab tabTitle="Mobile" tabIcon="smartphone-outline">
          <div class="form-group">
            <label for="mobilelogo" class="label">Logo</label>
            <img class="theme-image" [src]="themeimages.mobile_theme.logoImage"/>
            <input type="file" nbInput fullWidth id="mobilelogo" name="mobilelogo" (change)="actualizarArchivo('mobilelogo',$event.target.files)" />
          </div>
          <div class="form-group">
            <label for="mobilesplash" class="label">Imagen Splash</label>
            <img class="theme-image" [src]="themeimages.mobile_theme.splashImage"/>
            <input type="file" nbInput fullWidth id="mobilesplash" name="mobilesplash" (change)="actualizarArchivo('mobilesplash',$event.target.files)"/>
          </div>
          <div class="form-group">
            <label for="mobilebackground" class="label">Imagen de fondo</label>
            <img class="theme-image" [src]="themeimages.mobile_theme.backgroundImage"/>
            <input type="file" nbInput fullWidth id="mobilebackground" name="mobilebackground" (change)="actualizarArchivo('mobilebackground',$event.target.files)"/>
          </div>
        </nb-tab>
        <nb-tab tabTitle="Menús" tabIcon="menu-outline">
          <div class="form-group">
            <ng2-smart-table [settings]="settings" [source]="source" >
            </ng2-smart-table>
          </div>
        </nb-tab>

      </nb-tabset>
    </nb-card-body>
  </nb-card>
</div>

</div>
<div class="row">
  <div class="col-md-12">
    <button nbButton fullWidth status="primary" (click)="guardar()" ><nb-icon icon="save"></nb-icon>Guardar</button>
  </div>

</div>
</form>

